import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Flex from '../Flex';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const ModalContent = ({
  children,
}) => (
  <Flex
    className={classnames(
      'relative w-full h-full pointer-events-auto bg-white lg:h-auto',
      'bg-auto rounded outline-none shadow-xl overflow-hidden',
    )}
  >
    {children}
  </Flex>
);

ModalContent.propTypes = propTypes;

export default ModalContent;
